import React, { useContext, useEffect, useRef, useState } from "react"
import styled from "styled-components"
import useSound from "use-sound"
import { AppContext } from "../../context/createContext"
import BonusRound from "./main/bonusRound/BonusRound"
import Collect from "./main/collect/Collect"
import winSFX from "../../lib/audio/win.mp3"

export default function Jackpot({ handleJackpotPopup, setIsJackpot }: any) {
  const { jackpot, audio, timer } = useContext(AppContext)
  const { timeleft, winamount, status } = jackpot
  const now: any = new Date().getTime()

  const currentTime = (+timeleft + 1 - (now - Number(timer)) / 1000).toFixed(0)
  const [collect, setCollect] = useState<boolean>(false)
  const [timePass, setTimePass] = useState<any>(currentTime)

  const handleCollect = (b: boolean) => setCollect(b)
  const [playWinSFX] = useSound(winSFX, {
    volume: parseFloat(audio.sound) / 100,
  })
  const audioRef = useRef<any>(false)

  useEffect(() => {
    let timeout: any
    if (Number(winamount) > 0 && !collect) {
      timeout = setTimeout(() => {
        setCollect(true)
      }, 5000)
      !audioRef.current && !audio.isSoundOff && playWinSFX()
      audioRef.current = true

      collect && clearTimeout(timeout)
    }
    return () => clearTimeout(timeout)
  }, [winamount, audio.isSoundOff, collect])

  useEffect(() => {
    let counter = 0
    const interval = setInterval(() => {
      setTimePass(+currentTime - counter)
      counter++
      Number(currentTime) - counter < 0 && clearInterval(interval)
    }, 1000)
    return () => clearInterval(interval)
  }, [timeleft])

  return (
    <Container collect={collect}>
      {collect ? (
        <Collect
          data={jackpot}
          handleJackpotPopup={handleJackpotPopup}
          setIsJackpot={setIsJackpot}
          isSoundOff={audio.isSoundOff}
          sound={audio.sound}
        />
      ) : (
        <BonusRound
          timer={timePass}
          state={status}
          handleCollect={handleCollect}
        />
      )}
    </Container>
  )
}

export const Container = styled.main<{ collect: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 17px;
  gap: 4px;
  margin: auto;
  background: rgba(11, 10, 13, 0.8);
  border-radius: 8px;
  position: absolute;
  top: 50%;
  right: 50%;
  height: fit-content;
  /* bottom: 0; */
  transform: translate(50%, 0%);
  animation: appear 1s linear;
  z-index: 1;
  padding: 20px;
  @keyframes appear {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @media only screen and (min-width: 320px) and (min-height: 640px) {
    /* top: 50%; */
    /* bottom: unset; */
    transform: translate(50%, -50%);
  }
  @media only screen and (min-width: 768px) {
    padding: 24px 24px 34px;
    /* transform: ${({ collect }) =>
      collect ? "translate(50%, -50%)" : "translate(50%, -50%)"}; */
  }
`
